export const ALLOWED_IMAGE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
];

const OUTPUT_MAX_PX = 800;
const OUTPUT_MAX_KB = 500;

export async function compressImageToJpeg(file: File): Promise<File> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);
    img.onload = async () => {
      URL.revokeObjectURL(objectUrl);
      const scale = Math.min(
        1,
        OUTPUT_MAX_PX / Math.max(img.width, img.height),
      );
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      canvas
        .getContext('2d')!
        .drawImage(img, 0, 0, canvas.width, canvas.height);
      let quality = 0.92;
      let blob: Blob | null = null;
      while (quality > 0.1) {
        blob = await new Promise<Blob | null>((res) =>
          canvas.toBlob(res, 'image/jpeg', quality),
        );
        if (!blob || blob.size <= OUTPUT_MAX_KB * 1024) {
          break;
        }
        quality -= 0.05;
      }
      if (!blob) {
        blob = await new Promise<Blob | null>((res) =>
          canvas.toBlob(res, 'image/jpeg', 0.1),
        );
      }
      if (!blob) {
        reject(new Error('Failed to compress image'));

        return;
      }
      resolve(new File([blob], 'project.jpg', { type: 'image/jpeg' }));
    };
    img.onerror = reject;
    img.src = objectUrl;
  });
}

export function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve((reader.result as string).split(',')[1]);
    reader.readAsDataURL(blob);
  });
}
